module.exports = __webpack_public_path__ + "static/footbed-1337f688b3cdfc27e38ad5f7a800ee8d.png";